import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { codFiscaleValidMsg } from 'beebee-base/lib/utility';
import { cached, tracked } from '@glimmer/tracking';
import { inject } from '@ember/service';
import getConfig from 'beebee-base/lib/get-config';
import { applyStyle, _saveAll, _safeReload, _sortedCustomFields, _createLabel } from '../lib/utility.js';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _dec64, _dec65, _dec66, _dec67, _dec68, _dec69, _dec70, _dec71, _dec72, _dec73, _dec74, _dec75, _dec76, _dec77, _dec78, _dec79, _dec80, _dec81, _dec82, _dec83, _dec84, _dec85, _dec86, _dec87, _dec88, _dec89, _dec90, _dec91, _dec92, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89, _descriptor90, _descriptor91, _descriptor92, _descriptor93, _descriptor94, _descriptor95;
let ContactModel = (_dec = attr('boolean'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = belongsTo('organization', {
  inverse: null,
  async: false
}), _dec6 = attr('boolean'), _dec7 = attr('string'), _dec8 = attr('boolean', {
  defaultValue: false,
  allowNull: true
}), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('string'), _dec10 = attr('boolean', {
  defaultValue: null,
  allowNull: true
}), _dec11 = attr('boolean', {
  allowNull: true
}), _dec12 = attr('string'), _dec13 = attr('string'), _dec14 = attr('string'), _dec15 = attr('string', {
  defaultValue: 'Italia'
}), _dec16 = attr('string'), _dec17 = attr('string'), _dec18 = hasMany('address', {
  inverse: null,
  async: false
}), _dec19 = attr('string'), _dec20 = attr('string'), _dec21 = attr('string'), _dec22 = attr('string'), _dec23 = attr('string'), _dec24 = attr('string'), _dec25 = attr('string'), _dec26 = attr('boolean'), _dec27 = attr('string'), _dec28 = attr('string'), _dec29 = attr('number'), _dec30 = attr('string'), _dec31 = attr('string'), _dec32 = attr('string'), _dec33 = attr('string'), _dec34 = attr('boolean'), _dec35 = attr('string'), _dec36 = attr('string'), _dec37 = hasMany('contact', {
  inverse: null,
  async: true
}), _dec38 = hasMany('product', {
  inverse: null,
  async: true
}), _dec39 = hasMany('project', {
  inverse: null,
  async: true
}), _dec40 = hasMany('event', {
  inverse: null,
  async: true
}), _dec41 = hasMany('payment', {
  inverse: null,
  async: true
}), _dec42 = hasMany('invoice', {
  inverse: null,
  async: true
}), _dec43 = hasMany('expense', {
  inverse: null,
  async: true
}), _dec44 = hasMany('workhour', {
  inverse: null,
  async: true
}), _dec45 = hasMany('file', {
  inverse: 'contact',
  async: false
}), _dec46 = hasMany('custom_field', {
  inverse: null,
  async: true
}), _dec47 = hasMany('assurance', {
  inverse: null,
  async: true
}), _dec48 = attr('number', {
  defaultValue: 0
}), _dec49 = attr('number', {
  defaultValue: 0
}), _dec50 = attr('number', {
  defaultValue: 0
}), _dec51 = attr('number', {
  defaultValue: 0
}), _dec52 = attr('number', {
  defaultValue: 0
}), _dec53 = attr('number', {
  defaultValue: 0
}), _dec54 = attr('number', {
  defaultValue: 0
}), _dec55 = belongsTo('contact_state', {
  inverse: null,
  async: false
}), _dec56 = belongsTo('role', {
  inverse: null,
  async: false
}), _dec57 = hasMany('contact_parent', {
  inverse: null,
  async: false
}), _dec58 = attr('string'), _dec59 = attr('string'), _dec60 = attr('string'), _dec61 = attr('number'), _dec62 = attr('string'), _dec63 = attr('number'), _dec64 = attr('number'), _dec65 = attr('string'), _dec66 = attr('number'), _dec67 = attr('string'), _dec68 = attr('string'), _dec69 = attr('string'), _dec70 = attr('string'), _dec71 = attr('string'), _dec72 = attr('string'), _dec73 = attr('string'), _dec74 = attr('string'), _dec75 = attr('string'), _dec76 = hasMany('invoice_style', {
  inverse: null,
  async: true
}), _dec77 = attr('string'), _dec78 = attr('boolean'), _dec79 = attr('string'), _dec80 = hasMany('reminder_setting', {
  inverse: 'contact',
  async: false
}), _dec81 = attr('string'), _dec82 = hasMany('user_calendar', {
  inverse: 'user',
  async: false
}), _dec83 = hasMany('user_tax', {
  inverse: 'contact',
  async: false
}), _dec84 = hasMany('user_sezionale', {
  inverse: 'contact',
  async: false
}), _dec85 = belongsTo('user_invoice_setting', {
  inverse: 'contact',
  async: false
}), _dec86 = hasMany('contact_consensi', {
  inverse: null,
  async: false
}), _dec87 = attr('string'), _dec88 = attr('string'), _dec89 = attr('string'), _dec90 = attr('string'), _dec91 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec92 = attr('boolean', {
  defaultValue: false
}), _class = class ContactModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "checked", _descriptor3, this);
    _initializerDefineProperty(this, "archivied", _descriptor4, this);
    _initializerDefineProperty(this, "created_at", _descriptor5, this);
    _initializerDefineProperty(this, "updated_at", _descriptor6, this);
    _initializerDefineProperty(this, "intercom_user_jwt", _descriptor7, this);
    _initializerDefineProperty(this, "organization", _descriptor8, this);
    _initializerDefineProperty(this, "organization_admin", _descriptor9, this);
    _initializerDefineProperty(this, "username", _descriptor0, this);
    _initializerDefineProperty(this, "fisica_giuridica", _descriptor1, this);
    _initializerDefineProperty(this, "first_name", _descriptor10, this);
    _initializerDefineProperty(this, "last_name", _descriptor11, this);
    _initializerDefineProperty(this, "ragione_sociale", _descriptor12, this);
    _initializerDefineProperty(this, "sesso", _descriptor13, this);
    _initializerDefineProperty(this, "ente_pa", _descriptor14, this);
    _initializerDefineProperty(this, "data_nascita", _descriptor15, this);
    _initializerDefineProperty(this, "luogo_nascita", _descriptor16, this);
    _initializerDefineProperty(this, "provincia_nascita", _descriptor17, this);
    _initializerDefineProperty(this, "nazione_nascita", _descriptor18, this);
    _initializerDefineProperty(this, "mail", _descriptor19, this);
    _initializerDefineProperty(this, "pec", _descriptor20, this);
    _initializerDefineProperty(this, "addresses", _descriptor21, this);
    _initializerDefineProperty(this, "leg_rapp_name", _descriptor22, this);
    _initializerDefineProperty(this, "leg_rapp_data", _descriptor23, this);
    _initializerDefineProperty(this, "contact", _descriptor24, this);
    _initializerDefineProperty(this, "telephone", _descriptor25, this);
    _initializerDefineProperty(this, "mobile", _descriptor26, this);
    _initializerDefineProperty(this, "fax", _descriptor27, this);
    _initializerDefineProperty(this, "web_site", _descriptor28, this);
    _initializerDefineProperty(this, "set_event_color", _descriptor29, this);
    _initializerDefineProperty(this, "color", _descriptor30, this);
    _initializerDefineProperty(this, "notes", _descriptor31, this);
    _initializerDefineProperty(this, "credit", _descriptor32, this);
    _initializerDefineProperty(this, "thumbnail_url", _descriptor33, this);
    _initializerDefineProperty(this, "thumbnail_name", _descriptor34, this);
    _initializerDefineProperty(this, "thumbnail_etag", _descriptor35, this);
    _initializerDefineProperty(this, "thumbnail_type", _descriptor36, this);
    _initializerDefineProperty(this, "dispo_online", _descriptor37, this);
    _initializerDefineProperty(this, "lang", _descriptor38, this);
    _initializerDefineProperty(this, "nazionalita", _descriptor39, this);
    _initializerDefineProperty(this, "related_contacts", _descriptor40, this);
    _initializerDefineProperty(this, "products", _descriptor41, this);
    _initializerDefineProperty(this, "projects", _descriptor42, this);
    _initializerDefineProperty(this, "events", _descriptor43, this);
    _initializerDefineProperty(this, "payments", _descriptor44, this);
    _initializerDefineProperty(this, "invoices", _descriptor45, this);
    _initializerDefineProperty(this, "expenses", _descriptor46, this);
    _initializerDefineProperty(this, "workhours", _descriptor47, this);
    _initializerDefineProperty(this, "files", _descriptor48, this);
    _initializerDefineProperty(this, "custom_fields", _descriptor49, this);
    _initializerDefineProperty(this, "assurances", _descriptor50, this);
    _initializerDefineProperty(this, "total_files_number", _descriptor51, this);
    _initializerDefineProperty(this, "total_contacts_number", _descriptor52, this);
    _initializerDefineProperty(this, "total_projects_number", _descriptor53, this);
    _initializerDefineProperty(this, "total_products_number", _descriptor54, this);
    _initializerDefineProperty(this, "total_payments_number", _descriptor55, this);
    _initializerDefineProperty(this, "total_events_number", _descriptor56, this);
    _initializerDefineProperty(this, "total_related_contacts_number", _descriptor57, this);
    _initializerDefineProperty(this, "contact_state", _descriptor58, this);
    _initializerDefineProperty(this, "role", _descriptor59, this);
    _initializerDefineProperty(this, "contact_parents", _descriptor60, this);
    /*
     * General preferences
     */
    _initializerDefineProperty(this, "from_mail_message", _descriptor61, this);
    _initializerDefineProperty(this, "mail_message", _descriptor62, this);
    _initializerDefineProperty(this, "cc_mail_message", _descriptor63, this);
    _initializerDefineProperty(this, "calendar_step_minute", _descriptor64, this);
    _initializerDefineProperty(this, "calendar_default_view", _descriptor65, this);
    _initializerDefineProperty(this, "calendar_first_hour", _descriptor66, this);
    _initializerDefineProperty(this, "calendar_last_hour", _descriptor67, this);
    _initializerDefineProperty(this, "start_yearmonth", _descriptor68, this);
    _initializerDefineProperty(this, "start_yearday", _descriptor69, this);
    /*
     * Invoice preferences
     */
    _initializerDefineProperty(this, "piva", _descriptor70, this);
    _initializerDefineProperty(this, "cod_fiscale", _descriptor71, this);
    _initializerDefineProperty(this, "piva_name", _descriptor72, this);
    _initializerDefineProperty(this, "invoice_from", _descriptor73, this);
    _initializerDefineProperty(this, "invoice_notes", _descriptor74, this);
    _initializerDefineProperty(this, "invoice_piva", _descriptor75, this);
    _initializerDefineProperty(this, "paypal", _descriptor76, this);
    _initializerDefineProperty(this, "terms", _descriptor77, this);
    _initializerDefineProperty(this, "codice_destinatario", _descriptor78, this);
    _initializerDefineProperty(this, "invoice_styles", _descriptor79, this);
    _initializerDefineProperty(this, "socket_room", _descriptor80, this);
    _initializerDefineProperty(this, "enable_trello", _descriptor81, this);
    _initializerDefineProperty(this, "fresh_restore_id", _descriptor82, this);
    _initializerDefineProperty(this, "reminder_settings", _descriptor83, this);
    _initializerDefineProperty(this, "time_zone", _descriptor84, this);
    _initializerDefineProperty(this, "user_calendars", _descriptor85, this);
    _initializerDefineProperty(this, "user_taxes", _descriptor86, this);
    _initializerDefineProperty(this, "user_sezionales", _descriptor87, this);
    _initializerDefineProperty(this, "user_invoice_setting", _descriptor88, this);
    _initializerDefineProperty(this, "contact_consensis", _descriptor89, this);
    _initializerDefineProperty(this, "google_login", _descriptor90, this);
    _initializerDefineProperty(this, "google_cal", _descriptor91, this);
    _initializerDefineProperty(this, "livi_url", _descriptor92, this);
    _initializerDefineProperty(this, "physitrack", _descriptor93, this);
    _initializerDefineProperty(this, "current_users", _descriptor94, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor95, this);
  }
  get idArray() {
    return [this.id];
  }
  saveAll(model) {
    const styleName = this.session.option_field?.model_custom_style?.contact;
    if (styleName) {
      model.setProperties({
        last_name: model.last_name ? applyStyle(model.last_name, styleName) : null,
        first_name: model.first_name ? applyStyle(model.first_name, styleName) : null,
        ragione_sociale: model.ragione_sociale ? applyStyle(model.ragione_sociale, styleName) : null
      });
    }
    model.setProperties({
      piva: model.piva ? model.piva.replace(/\s/g, '') : null,
      cod_fiscale: model.cod_fiscale ? model.cod_fiscale.replace(/\s/g, '') : null
    });
    if (model.fisica_giuridica || model.ente_pa) {
      model.setProperties({
        last_name: null,
        first_name: null
      });
    }
    return _saveAll(model, this.session, 'contacts_all');
  }
  safeReload() {
    return _safeReload(this);
  }
  get name() {
    const styleName = this.session.option_field?.model_custom_style?.contact;
    if ((this.fisica_giuridica || this.ente_pa) && this.ragione_sociale?.trim()) {
      return applyStyle(this.ragione_sociale, styleName);
    } else {
      const firstName = this.first_name ?? '';
      const lastName = this.last_name ?? '';
      const fullName = `${lastName} ${firstName}`.trim();
      return applyStyle(fullName, styleName);
    }
  }
  get thumbnail_api_url() {
    if (!this.session.token || !this.thumbnail_url) {
      return null;
    }
    return `${getConfig(this).APP.urlApi}/app/file?access_token=${this.session.token}&name=${encodeURIComponent(this.thumbnail_name ?? '')}&url=${encodeURIComponent(this.thumbnail_url)}`;
  }
  get sorted_custom_fields() {
    let fields;
    try {
      fields = this.custom_fields;
    } catch {
      return [];
    }
    if (Array.isArray(fields)) {
      return _sortedCustomFields(fields, this.isDeleted);
    }
    if (fields && typeof fields.then === 'function') {
      return fields.then(resolvedFields => _sortedCustomFields(resolvedFields, this.isDeleted));
    }
    return [];
  }
  get filtered_contact_parents() {
    return this.contact_parents.filter(item => {
      return item.parent?.id !== this.id;
    });
  }
  get label() {
    const cLabel = this.session.option_field?.model_custom_label?.contact?.label;
    if (cLabel) {
      return _createLabel(this, cLabel, this.session, this.intl, this.currency);
    }
    return this.name || '';
  }
  get sub_label() {
    const cSubLabel = this.session.option_field?.model_custom_label?.contact?.sub_label;
    if (cSubLabel) {
      return _createLabel(this, cSubLabel, this.session, this.intl, this.currency);
    }
    return `${this.cod_fiscale || ''} ${this.piva || ''}`;
  }
  get status_name() {
    return this.contact_state?.status_name;
  }
  get firstLetters() {
    const name = this.name || '';
    const words = name.trim().split(' ');
    const initials = words.filter(word => word.length > 0).slice(0, 3).map(word => word[0].toUpperCase()).join('');
    return initials || '-';
  }
  get firstLetter() {
    if (this.name && this.name.length > 0) {
      return this.name[0].toLowerCase();
    }
    return '';
  }
  get codFiscaleValidMsg() {
    const location_address_country = this.addresses?.[0]?.location_address_country;
    return codFiscaleValidMsg(this.cod_fiscale, this.fisica_giuridica, this.ragione_sociale, location_address_country, this.first_name, this.last_name);
  }
  get current_users_label() {
    return this.current_users.map(user => user.label).join(' ');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "checked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "archivied", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "updated_at", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intercom_user_jwt", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "organization", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "organization_admin", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "username", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "fisica_giuridica", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "first_name", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "last_name", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "ragione_sociale", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "sesso", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "ente_pa", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "data_nascita", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "luogo_nascita", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "provincia_nascita", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "nazione_nascita", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "mail", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "pec", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "addresses", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "leg_rapp_name", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "leg_rapp_data", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "telephone", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "mobile", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "fax", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "web_site", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "set_event_color", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "credit", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_url", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_name", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_etag", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_type", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "dispo_online", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "lang", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "nazionalita", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "related_contacts", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "products", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "projects", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "events", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "payments", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "invoices", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "expenses", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "workhours", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "custom_fields", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sorted_custom_fields", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sorted_custom_fields"), _class.prototype), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "assurances", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "total_files_number", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "total_contacts_number", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "total_projects_number", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "total_products_number", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "total_payments_number", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "total_events_number", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "total_related_contacts_number", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "contact_state", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "role", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "contact_parents", [_dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "from_mail_message", [_dec58], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "mail_message", [_dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "cc_mail_message", [_dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "calendar_step_minute", [_dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "calendar_default_view", [_dec62], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "calendar_first_hour", [_dec63], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "calendar_last_hour", [_dec64], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "start_yearmonth", [_dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "start_yearday", [_dec66], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "piva", [_dec67], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "cod_fiscale", [_dec68], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "piva_name", [_dec69], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "invoice_from", [_dec70], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "invoice_notes", [_dec71], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "invoice_piva", [_dec72], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "paypal", [_dec73], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "terms", [_dec74], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "codice_destinatario", [_dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "invoice_styles", [_dec76], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "socket_room", [_dec77], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "enable_trello", [_dec78], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "fresh_restore_id", [_dec79], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "reminder_settings", [_dec80], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "time_zone", [_dec81], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "user_calendars", [_dec82], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "user_taxes", [_dec83], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "user_sezionales", [_dec84], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "user_invoice_setting", [_dec85], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "contact_consensis", [_dec86], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor90 = _applyDecoratedDescriptor(_class.prototype, "google_login", [_dec87], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor91 = _applyDecoratedDescriptor(_class.prototype, "google_cal", [_dec88], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor92 = _applyDecoratedDescriptor(_class.prototype, "livi_url", [_dec89], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor93 = _applyDecoratedDescriptor(_class.prototype, "physitrack", [_dec90], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor94 = _applyDecoratedDescriptor(_class.prototype, "current_users", [_dec91], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor95 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec92], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ContactModel as default };
//# sourceMappingURL=contact.js.map
